import React from 'react';

export default function IconLock({ currentColor = 'white' }) {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M11.3333 5.33333V6H4.66667V5.33333C4.66667 3.49238 6.15905 2 8 2C9.84095 2 11.3333 3.49238 11.3333 5.33333ZM2.66667 6V5.33333C2.66667 2.38781 5.05448 0 8 0C10.9455 0 13.3333 2.38781 13.3333 5.33333V6H14.6667C15.403 6 16 6.59696 16 7.33334V14.6667C16 15.403 15.403 16 14.6667 16H1.33333C0.596953 16 0 15.403 0 14.6667L0 7.33334C0 6.59696 0.596954 6 1.33333 6H2.66667ZM9.33333 10.8333C9.33333 11.5697 8.73638 12.1667 8 12.1667C7.26362 12.1667 6.66667 11.5697 6.66667 10.8333C6.66667 10.097 7.26362 9.5 8 9.5C8.73638 9.5 9.33333 10.097 9.33333 10.8333Z" fill={currentColor} />
    </svg>
  );
}
